import { Injectable } from '@angular/core';
import {ReactiveService} from '../reactive-service.abstract';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ScheduleTemplateModel, ScheduleTemplatePeriodModel} from './scheduletemplate.model';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';

@Injectable()
export class ScheduleTemplateApiService extends ReactiveService implements Resolve<ScheduleTemplateModel> {
  private baseUrl = environment.backEndUrlPrefix + '/' + 'db/scheduletemplate';

  constructor(private http: HttpClient) {
    super();
  }

  create(data: ScheduleTemplateModel): Observable<ScheduleTemplateModel> {
    return this.http.post<ScheduleTemplateModel>(`${this.baseUrl}`, data);
  }

  save(scheduletemplateId: number, data: ScheduleTemplateModel): Observable<ScheduleTemplateModel> {
    return this.http.put<ScheduleTemplateModel>(`${this.baseUrl}/${scheduletemplateId}`, data);
  }
  getScheduleTemplate(scheduletemplateId: number): Observable<ScheduleTemplateModel> {
    return this.http.get<ScheduleTemplateModel>(`${this.baseUrl}/${scheduletemplateId}`);
  }

  getScheduleTemplateDaily(scheduletemplateId: number, objectId: number, date?: number): Observable<ScheduleTemplatePeriodModel> {
    return this.http.get<ScheduleTemplatePeriodModel>(`${this.baseUrl}/${scheduletemplateId}/daily`, {params: {objectId: objectId + '', date: date + ''}});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ScheduleTemplateModel> | Promise<ScheduleTemplateModel> | ScheduleTemplateModel {
    return this.getScheduleTemplate(route.params.scheduletemplateId);
  }
}
